export default __webpack_public_path__ + "static/media/asset-9.a969d18d.webp";